import { Box, Modal } from '@mui/material'
import type React from 'react'

interface ImageModalProps {
  open: boolean
  imagePath: string | null
  onClose: () => void
}

export const ImageModal: React.FC<ImageModalProps> = ({ open, imagePath, onClose }) => {
  if (!imagePath) return null

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="image-modal" aria-describedby="fullsize-image">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: '90vw',
          maxHeight: '90vh',
          overflow: 'auto',
        }}
      >
        <img src={imagePath || '/placeholder.svg'} alt="Full size" style={{ width: '100%', height: 'auto' }} />
      </Box>
    </Modal>
  )
}
